import { userHasLevel } from "../../../engine/AuthRoute";
import {
  languagesList,
  levels,
  modeInterpretariat,
  renderUserNameEmail,
  roles,
  statusPrestations,
  statusPrestationsActual,
  statusPrestationsValues,
  subRoles,
  typeIntervention,
} from "../../../utils/constants";
import { AiFillCalendar } from "react-icons/ai";
import React, { useContext } from "react";
import dayjs from "../../../utils/dayjs";
import { BiLinkExternal } from "react-icons/bi";
import { typesPrestation } from "../../../utils/typesPrestation";
import { Alert, Button, Space } from "antd";
import { IoAddSharp } from "react-icons/io5";
import { CreateApplicant } from "../../../shared/components/CreateApplicant/CreateApplicant";
import { modalsByContext } from "../../../shared/components/Modals/modals";
import { typeAddress } from "../../../shared/container/Addresses/AddresseItem/AddresseHelpers";
import { ModalContext } from "../../../engine/context/Modal.provider";
import { LuMapPin } from "react-icons/lu";
import { usePrestationDisabler } from "../../../engine/hooks/usePrestationDisabler";
import { isArray } from "lodash";

import { useTranslation } from "react-i18next";
import { t } from "i18next";
import { UserContext } from "../../../engine/context/User.context";

export const prestationInputs = (
  prestation,
  formRef,
  change,
  setChange,
  user,
  dataForm,
  setDataForm,
) => {
  const {
    intervention: { startDate, endDate, location, extra },
    comment,
    applicationAt = null,
    category,
    institution,
    applicant,
    isSequentialPrestation,
  } = prestation;

  const context = useContext(ModalContext);

  let isDraft = prestation.status === statusPrestationsValues.draft;

  const setAdressByList = () => {
    let selected = formRef.current.getFieldValue("intervention.locationTo");

    const addresses = formRef.current["_intervention.locationTo"];

    let findAddress = addresses.find(e => e._id === selected);

    formRef.current.setFieldsValue({
      "intervention.location": findAddress.maps,
      "intervention.locationName": findAddress.location,
    });
  };

  return [
    {
      parentLabel: "",
      children: [
        {
          label: t("prestationInputs.orderNumber"),
          placeholder: t("prestationInputs.generatedAutomatically"),
          name: "reference",
          disabled: true,
          capitalize: false,
          type: "input",
          variant: "important",
          col: 24,
        },
        {
          label: t("prestationInputs.applicantInstitution"),
          disabled:
            !isDraft ||
            !userHasLevel({
              not: {
                [roles.institution]: "", //
              },
            }),
          name: "institution",
          value: userHasLevel({
            not: {
              [roles.institution]: "", //
            },
          })
            ? institution?._id
            : user.institution,
          type: "dynamic-select",
          required: true,
          endPoint: "institutions",
          itemsCallBack: (institutions, form) => {},
          itemCallback: item => {
            return {
              key: item._id,
              label: `${item.name}`,
              value: item._id,
            };
          },
          col: 24,
        },
        {
          label: t("prestationInputs.category"),
          name: "category",
          showSearch: true,
          value: category,
          watchRenderCondition: true,
          multiple: true,
          type: "select",
          selectContent: typesPrestation,
          selectType: "group",
          col: 24,
          watchDynamicObject: "institution",
          filterContent: (item, institution) => {
            if (institution?.mainType && institution?.mainType !== "") {
              return item.label === institution?.mainType;
            } else {
              return true;
            }
          },
        },
        {
          label: t("prestationInputs.status"),
          name: "status",
          disabled: true,
          type: "select",
          selectContent: statusPrestationsActual,
          col: 24,
        },
        {
          required: true,
          showSearch: true,
          disabled: !isDraft,
          label: t("prestationInputs.serviceLanguage"),
          name: "languages",
          value: prestation.languages,
          type: "dynamic-select",
          endPoint: "users/languages",
          col: 24,
          // onChange: value => {
          //   setLanguageSearch(value);
          // },
          itemCallback: item => {
            return {
              key: item.value,
              label: `${
                languagesList().find(e => e.value === item.value).label
              }`,
              value: item.value,
            };
          },
        },
        {
          label: t("prestationInputs.requestSubmissionDate"),
          quote: t("prestationInputs.automaticOnOrderConfirmation"),
          name: "applicationAt",
          visible: userHasLevel({
            only: {
              [roles.permanance]: "crud", //
              [roles.admin]: "crud", //
            },
          }),
          value: applicationAt === null ? undefined : dayjs(applicationAt),
          suffixIcon: <AiFillCalendar />,
          showTime: true,
          showClear: true,
          type: "date-time",
          col: 24,
        },
        {
          required: true,
          label: t("prestationInputs.startDateTime"),
          name: "intervention.startDate",
          value: dayjs(startDate),
          suffixIcon: <AiFillCalendar />,
          onChange: props => {
            let val;

            if (props.format !== undefined) {
              val = props.format();
            }

            if (props.value !== undefined) {
              val = props.value.format();
            }

            setDataForm({
              ...dataForm,
              "intervention.startDate": val,
            });
          },
          showTime: true,
          watch: "intervention.endDate",
          watchRenderCondition: false,
          watchValuesCallback: (start, end, ref) => {
            try {
              if (!end || !start) return;

              // Check the difference in minutes
              const differenceInMinutes = end.diff(start, "minute");

              // If start is after or exactly at the same time as end
              if (differenceInMinutes <= 0) {
                // let newStartD = end.subtract(1, "hour");
                // ref.current.setFieldsValue({
                //   "intervention.startDate": newStartD,
                // });
                // setDataForm({
                //   ...dataForm,
                //   "intervention.startDate": newStartD.format(),
                // });
              }
            } catch (e) {
              console.log(e);
            }
          },
          type: "date-time",
          col: 12,
        },
        {
          required: true,
          label: t("prestationInputs.endDateTime"),
          name: "intervention.endDate",
          value: dayjs(endDate),
          suffixIcon: <AiFillCalendar />,
          onChange: props => {
            let val;

            if (props.format !== undefined) {
              val = props.format();
            }

            if (props.value !== undefined) {
              val = props.value.format();
            }
            setDataForm({
              ...dataForm,
              "intervention.endDate": val,
            });
          },
          watch: "intervention.startDate",
          watchRenderCondition: false,
          watchValuesCallback: (end, start, ref) => {
            try {
              if (!end || !start) return;

              // Check the difference in minutes
              const differenceInMinutes = start.diff(end, "minute");

              // If end is before or exactly at the same time as start
              if (differenceInMinutes >= 0) {
                let newEndD = start.add(1, "hour");
                ref.current.setFieldsValue({
                  "intervention.endDate": newEndD,
                });
                setDataForm({
                  ...dataForm,
                  "intervention.endDate": newEndD.format(),
                });
              }
            } catch (e) {
              console.log(e);
            }
          },
          showTime: true,
          type: "date-time",
          col: 12,
        },
        {
          col: 24,
          type: "component",
          name: "durationHour",
          component: () => (
            <DurationHourChecker
              keys={["intervention.startDate", "intervention.endDate"]}
              dataForm={dataForm}
              setDataForm={setDataForm}
            />
          ),
        },
      ],
    },
    typeInterventionInputs(),
    {
      parentLabel: t("prestationInputs.interventionLocationInstitution"),
      children: [
        {
          type: "component",
          watchDynamicObject: "institution",
          watchRenderCondition: true,
          component: ({ disabled }) => {
            return (
              <Space direction={"horizontal"}>
                <Button
                  disabled={disabled}
                  type={"primary"}
                  onClick={() => {
                    let instituionId = formRef.current.getFieldValue(
                      "institution",
                    );
                    context.openModal(
                      modalsByContext.InstitutionSelectAddress,
                      {
                        institution: instituionId,
                        formRef,
                      },
                      ({ _id, data }) => {
                        if (data) {
                          formRef.current.setFieldsValue({
                            "intervention.location": data.maps,
                            "intervention.locationName": data.location,
                          });
                          setChange(_id);
                        }
                      },
                    );
                  }}
                  icon={
                    <LuMapPin
                      style={{
                        marginTop: "0px",
                      }}
                      size={15}
                    />
                  }
                  size={"small"}
                >
                  {t("prestationInputs.selectPredefinedLocation")}
                </Button>
                <Button
                  disabled={disabled}
                  type={"primary"}
                  onClick={() => {
                    let instituionId = formRef.current.getFieldValue(
                      "institution",
                    );
                    context.openModal(
                      modalsByContext.InstitutionNewAddress,
                      {
                        institution: instituionId,
                        principal: null,
                        type: typeAddress.maps,
                      },
                      ({ _id, data }) => {
                        if (data) {
                          formRef.current.setFieldsValue({
                            "intervention.location": data.maps,
                            "intervention.locationName": data.location,
                          });
                          setChange(_id);
                        }
                      },
                    );
                  }}
                  size={"small"}
                  style={{
                    justifySelf: "flex-start",
                    display: "flex",
                  }}
                  icon={
                    <IoAddSharp
                      style={{
                        marginTop: "0px",
                      }}
                      size={25}
                    />
                  }
                >
                  {t("prestationInputs.addInterventionLocation")}
                </Button>
              </Space>
            );
          },
          col: 24,
        },
        {
          label: t("prestationInputs.interventionLocationInstitution"),
          name: "intervention.locationName",
          disabled: true,
          type: "input",
          watchRequiredCondition: true,
          watch: "intervention.type",
          watchValues: [typeIntervention.in_person],
          col: 24,
        },
        {
          label: t("prestationInputs.interventionAddress"),
          disabled: true,
          name: "intervention.location",
          watch: "intervention.type",
          watchValues: [typeIntervention.in_person],
          watchRequiredCondition: true,
          watchValuesCallback: (value, form, r) => {},
          value: prestation.intervention.location,
          type: "google-adress",
          col: 24,
          // watchDynamicObject: "institution",
          // watchDynamicSetEmpty: true,
          // watchRenderCondition: true,
          // watchDynamicSetter: institution => institution?.interventionLocation,
        },
        {
          visible:
            userHasLevel({
              only: {
                [roles.admin]: "crud", //
              },
            }) && [statusPrestationsValues.planned].includes(prestation.status),
          label: t("prestationInputs.interpreterDepartureLocation"),
          name: "intervention.locationFrom",
          value: prestation.intervention.locationFrom,
          type: "google-adress",
          col: 24,
        },
        {
          label: t("prestationInputs.interventionLocationExtra"),
          name: "intervention.extra",
          type: "input",
          watch: "intervention.type",
          watchValues: [
            typeIntervention.visio,
            typeIntervention.in_person,
            typeIntervention.phone,
          ],
          col: 24,
        },
        {
          label: t("prestationInputs.followedInterventionLabel"),
          description: (
            <span>{t("prestationInputs.followedInterventionDescription")}</span>
          ),
          name: "isSequentialPrestation",
          visible: userHasLevel({
            only: {
              [roles.admin]: "r", //
              [roles.permanance]: "r", //
            },
          }),
          type: "checkbox-bool",
          value: isSequentialPrestation,
          col: 24,
        },
      ],
    },
    {
      parentLabel: t("prestationInputs.interpreterCriteria"),
      children: [
        {
          required: true,
          label: t("prestationInputs.interpreterGender"),
          name: "search.searchGenre",
          type: "select",
          multiple: true,
          selectContent: [
            { label: t("prestationInputs.female"), value: "female" },
            { label: t("prestationInputs.male"), value: "male" },
          ],
          col: 24,
        },
        {
          required: true,
          label: t("prestationInputs.interpreterLevel"),
          name: "search.searchLevel",
          type: "select",
          multiple: true,
          selectContent: levels(),
          col: 24,
        },
      ],
    },
    {
      parentLabel: t("prestationInputs.applicantInformation"),
      children: [
        {
          label: t("prestationInputs.applicant"),
          name: "applicant",
          required: true,
          value: applicant?._id,
          type: "dynamic-select",
          endPoint: institution =>
            `/users?subRole=${subRoles.institutionDemander}&institution=${institution}&status=active`,
          watchDynamicObject: "institution",
          watchRenderCondition: true,
          watchDynamicSetEmpty: true,
          updateEndPoint: [change],
          itemsCallBack: (institutions, form) => {},
          itemCallback: item => {
            return {
              key: item._id,
              label: renderUserNameEmail(item),
              value: item._id,
            };
          },
          col: 24,
        },
        {
          type: "component",
          watchDynamicObject: "institution",
          watchRenderCondition: true,
          component: ({ disabled }) => {
            return (
              <>
                <CreateApplicant
                  disabled={disabled}
                  key={Math.random()}
                  name={"applicant"}
                  formRef={formRef}
                  onCreated={_id => {
                    setChange(_id);
                  }}
                />
              </>
            );
          },
          col: 24,
        },
      ],
    },
    {
      children: [
        {
          label: t("prestationInputs.saveAndNext"),
          name: "send",
          value: "send",
          type: "submit",
          col: 24,
          align: "right",
        },
      ],
    },
  ];
};

export const typeInterventionInputs = props => {
  const { configuration } = useContext(UserContext);

  let interpreteRef = props?.interpreteRef || null;
  let hidden = props?.hidden || false;

  let interpretingMode = interpreteRef?.interpreteData?.interpretingMode;

  let modeInterpretariatFinal = modeInterpretariat();

  if (isArray(interpretingMode)) {
    modeInterpretariatFinal = modeInterpretariat().map(p => {
      if (interpretingMode.includes(p.value)) {
        return p;
      } else {
        return { ...p, disabled: true };
      }
    });
  }

  return {
    parentLabel: null,
    children: [
      {
        label: t("prestationInputs.interventionType"),
        name: "intervention.type",
        required: true,
        type: "radios",
        radios: modeInterpretariatFinal,
        col: 24,
        hidden,
      },
      {
        label: t("prestationInputs.interventionPhone"),
        name: "intervention.phone",
        type: "input",
        required: true,
        watch: "intervention.type",
        addonBefore: "+41",
        watchRenderCondition: true,
        watchValues: [typeIntervention.phone],
        col: 24,
        hidden,
        visible: configuration?.prestation?.askPhoneInterventionPhone,
      },
      {
        label: t("prestationInputs.visioConferenceLink"),
        name: "intervention.linkVisio",
        type: "input",
        required: true,
        watch: "intervention.type",
        addonBefore: <BiLinkExternal />,
        watchRenderCondition: true,
        watchValues: [typeIntervention.visio],
        col: 24,
        hidden,
      },
    ],
  };
};

export const DurationHourChecker = ({ dataForm, setDataForm, keys }) => {
  if (dataForm?.[keys[0]] === undefined || dataForm?.[keys[1]] === undefined) {
    return <></>;
  }

  const durationMinutes = dayjs(dataForm?.[keys[1]]).diff(
    dayjs(dataForm?.[keys[0]]),
    "minute",
  );

  const durationHoursDay = dayjs(dataForm?.[keys[1]]).diff(
    dayjs(dataForm?.[keys[0]]),
    "hour",
  );

  const durationHours = Math.floor(durationMinutes / 60);
  const remainingMinutes = durationMinutes % 60;

  const pluralize = (count, singular, plural) =>
    count <= 1 ? singular : plural;

  if (durationMinutes >= 480 || durationMinutes < 60) {
    const description = (
      <span>
        {t("durationHourChecker.duration")}{" "}
        <b>
          {durationHours}{" "}
          {pluralize(
            durationHours,
            t("durationHourChecker.hourSingular"),
            t("durationHourChecker.hourPlural"),
          )}
        </b>
        {remainingMinutes > 0 ? (
          <>
            {" "}
            {t("durationHourChecker.and")}{" "}
            <b>
              {remainingMinutes}{" "}
              {pluralize(
                remainingMinutes,
                t("durationHourChecker.minuteSingular"),
                t("durationHourChecker.minutePlural"),
              )}
            </b>
          </>
        ) : (
          ""
        )}
      </span>
    );

    const lessOneMinute = <span>{t("durationHourChecker.lessOneMinute")}</span>;

    return (
      <Alert
        message={t("durationHourChecker.errorMessage")}
        description={
          durationMinutes === 0 && durationHours <= 0
            ? lessOneMinute
            : description
        }
        type="error"
        showIcon
        closable={true}
      />
    );
  } else {
    return null;
  }
};
